import { useState, useEffect } from 'react';
import UserService from '../service/UserService';

export function useGetUser() {
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    UserService.getAllShowDisable(false)
      .then((response) => {
        if (response.data.data.length > 0) {
          let userOptionList = response.data.data.map((user) => {
            return { opportunityProprietary: user.login, label: user.name };
          });

          setUserList(userOptionList);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    userList,
    setUserList
  };
}
